<template>
    <div class="backboard">
        <div class="login-board">
            公開前作品の閲覧には認証が必要です。
            <input type="text" disabled name="username" :value="email">
            <input type="password" name="password" autocomplete="on" v-model="password">
            <div style="margin-top: 1.5em;">
                <button @click="onCancel">キャンセル</button>
                <button @click="onSend">認証</button>
            </div>
        </div>
    </div>
</template>

<script>
  let debugOut = false

  import DialogHelper from '@/DialogHelper'
  import {mapState} from 'vuex'

  let lastUid = ""
  export default {
    name: "auth",
    props: {
        authorID: {
          type: Number,
          required: true,
        },
        workID: {
          type: Number,
          required: true,
        },
        email: {
          type: String,
          required: true,
        },
    },
    created() {
      debugOut = this.$root.$options.debugOut
    },
    data() {
      return {
        password:"",
      }
    },
    watch: {
      nowLockKey(nv,ov) {
        if (debugOut) {console.log(`change key ${ov} => ${nv}`)}
      },
      nowUserID(nv,ov) {
        if (nv === null) return
        if (debugOut) {console.log(`change user ${ov} => ${nv}`)}
        let result = this.nowUserID === this.email
        this.$store.commit('setNowUserID',null)
        // this.$nextTick(() => {
          firebase.auth().signOut()
              .then(res => {
                if (debugOut) {console.log('logout!')}
              })
              .catch(error => {
                if (debugOut) {console.log(`logout failed:${error}`)}
              })
        // })
        this.$emit('result',result)
      },
    },
    computed: {
        ...mapState([
            'nowLockKey',
            'nowUserID',
        ]),
    },
    mounted() {
    },
    methods: {
      onCancel() {
        this.$emit('result',false)
      },
      onSend() {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).catch(function(error) {
          let errorCode = error.code
          let errorMessage = error.message
          DialogHelper.modalError(this,{message:`認証エラー (err = ${errorCode})\n'${errorMessage}'`})
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.backboard {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 100;
    pointer-events: auto;
}

.login-board {
    display: flex;
    flex-flow: column;
    position: fixed;
    width: 24em;
    height: 9em;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    border-style: solid;
    border-width: 1px;
    background-color: white;
    pointer-events: auto;
}

.login-board input {
    margin: 0.4em 2em;
    height: 1.5em;
}

.login-board button {
    min-width: 6em;
    margin: 0 1em;
}

</style>